import { render, staticRenderFns } from "./ExtractList.vue?vue&type=template&id=10ad8799&scoped=true&"
import script from "./ExtractList.vue?vue&type=script&lang=js&"
export * from "./ExtractList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ad8799",
  null
  
)

export default component.exports